<template lang="pug">
  .b-tabs
    ._item(v-for="item in items" :class="{ active: item.name === value }" @click="$emit('input', item.name)") {{ item.label }}
      ._count(v-if="item.count") {{ item.count }}
</template>

<script>
export default {
  name: 'BaseTabs2',
  props: {
    items: Array,
    value: String,
  },
};
</script>

<style scoped lang="scss">

.tabs {
  display: inline-flex;
  gap: 50px;
  border-bottom: 1px solid #D1D9F0;

  &__item {
    height: 42px;
    display: flex;
    gap: 8px;
    align-items: center;
    font-size: 15px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #1E3147;
    cursor: pointer;

    &.active {
      border-bottom: 2px solid #99A3C5;
    }
  }

  &__count {
    width: 20px;
    height: 20px;
    background: var(--color-super-light);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: var(--color-dark-gray);
    font-size: 10px;
    flex-shrink: 0;
  }

  @media(max-width: 1200px) {
    gap: 30px;
    overflow-y: scroll;
  }
}
</style>
